type RouteParams = Record<string, string | string[] | undefined>;

/**
 * 把实际路径归一为路由模板，如 `/project/abc` → `/project/[projectId]`。
 * 产品区按模板计页：同一页面的不同实体、同页 query 变化都算同一个页面，
 * 也避免把项目、会话等标识写进统计数据。参数名来自路由本身，不维护第二份路由表。
 */
export function toRouteTemplate(pathname: string, params: RouteParams): string {
    const names = new Map<string, string>();
    for (const [name, value] of Object.entries(params)) {
        for (const item of Array.isArray(value) ? value : value === undefined ? [] : [value]) {
            if (item) names.set(item, name);
        }
    }
    if (names.size === 0) return pathname;
    return pathname
        .split('/')
        .map((segment) => {
            let decoded = segment;
            try { decoded = decodeURIComponent(segment); } catch { /* 保留原段 */ }
            const name = names.get(decoded);
            return name ? `[${name}]` : segment;
        })
        .join('/');
}
